export default __webpack_public_path__ + "static/media/reload-icon.9b3f5804.svg";